export default __webpack_public_path__ + "static/media/avatar.4d4ce08c.png";